import { create } from "zustand";
import type { KlusModel } from "../models/KlusModel.ts";

type SelectedKlusState = {
  /** De geselecteerde klus; bepaalt of het sidepanel open is */
  selectedKlus: KlusModel | null;
  setSelectedKlus: (res: KlusModel | null | ((prev: KlusModel | null) => KlusModel | null)) => void;
  /** Minuten verschuiving tijdens actieve drag; 0 als geen drag actief */
  dragOffsetMinutes: number;
  setDragOffsetMinutes: (minutes: number) => void;
};

export const useKlusSelectedKlusStore = create<SelectedKlusState>()((set) => ({
  selectedKlus: null,
  setSelectedKlus: (res) =>
    set((state) => {
      const klusSelection = typeof res === "function" ? res(state.selectedKlus) : res;
      return { selectedKlus: klusSelection };
    }),
  dragOffsetMinutes: 0,
  setDragOffsetMinutes: (minutes) => set({ dragOffsetMinutes: minutes }),
}));
